export default __webpack_public_path__ + "static/media/3.bf809057.jpg";